import DocumentHistoryDownload from './documentHistoryDownload';

export default DocumentHistoryDownload;
